/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import cssClasses from "./AddLead.module.css";
import Close from "../../Components/Icons/Close";

import { useNavigate } from "react-router-dom";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import TimeComponent from "../../Subcomponents/TimeComponent";

import RightArrow from "../../Components/Icons/RightArrow";
// import SearchIcon from "../Icons/SearchIcon";

import MobileStepper from "@mui/material/MobileStepper";
import { Divider } from "@mui/material";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
//images
import backArrow from "../../Assets/Images/backArrow.svg";
import block from "../../Assets/Images/block.svg";
import AddIcon from "../../Assets/Images/addSitePrefernces.svg";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import Countdown, { zeroPad } from "react-countdown";

import debounce from "lodash.debounce";

//services
import {
  getPAN_cardDetails,
  getAadharCardDetails,
} from "../../Services/SurepassApi";
import { checkForUniqueDocs } from "../../Services/LoginService";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { sendOTPMessage, sendMailTo, sendMessage } from "../../Services/SmsService";
import {
  getNationality,
  getNative,
  getBudget,
  getProfessions,
  getProjectUnitType,
  // checkPersonExists,
  checkPhoneNumberIsBlackListed,
  addPersonTable,
  addLeadsTable,
  addLeadStatus,
  addKYCDoc,
  getProjects,
  addProjectPrefernces,
  checkPhoneNumberExists,
  getFormatedEmail,
  addLeadLogs,
  getAssignedProjects,
  getLeadDetails,
  sendWAMSG,
} from "../../Services/LeadService";
import { Network } from "@capacitor/network";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";

//react-phone-number-input
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { handleErrors } from "../../Services/LoginService";
import InfoIcon from "../../Components/Icons/InfoIcon";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";
import { uniq } from "lodash";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));

export default function AddLead({ open, handleClose, returnRespButton }) {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  const [personalDetail, setPersonalDetail] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    gender: "Male",
    disabledName: false,
    disabledPhoneNumber: false,
    disabledGender: false,
  });
  const [generalDetail, setGeneralDetail] = useState({
    nationality: "",
    native: "",
    worksIn: "",
    budget: "",
    disabledNationality: false,
    disabledNative: false,
    disabledWorksIn: false,
    disabledBudget: false,
  });
  const [projectFieldArray, setProjectFieldArray] = useState([
    {
      selectedProject: "",
      flatUnitType: "",
      SitePrefernces: null,
      availableUnitType: [],
      isPrimary: true,
      alreadyAdded: false,
      selectedProjectData: null
    },
  ]);
  const helperTextObj = {
    selectedProject: "",
    flatUnitType: "",
    SitePrefernces: "",
  };
  const [projectFieldHelperText, setProjectFieldHelperText] = useState([
    helperTextObj,
  ]);
  const [projectNameList, setProjectNameList] = useState([]);
  const [projectUnitArray, setProjectUnitArray] = useState([]);
  const [panNumber, setPanNumber] = useState("");
  const [panName, setPanName] = useState("");
  const [panObject, setPanObject] = useState(null);
  const [helperText, setHelperText] = useState({
    name: "",
    email: "",
    isPhoneNumber: "",
    panNumber: "",
    isPanValid: false,
    nationality: "",
    native: "",
    worksIn: "",
    budget: "",
  });
  const [totalSteps, setTotalStep] = useState(6);
  const [activeStep, setActiveStep] = React.useState(1);
  const [personalButtonNext, setPersonalButtonNext] = useState(false);
  const [generalButtonNext, setGeneralButtonNext] = useState(false);
  const [projectButtonNext, setProjectButtonNext] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [isInterNational, setIsInterNational] = useState(false);
  const [recievedOtp, setRecievedOtp] = useState(null);
  const [otptimer, setOtpTimer] = useState(false);
  const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const [wroksIn, setWorksIn] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [native, setNative] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const [personExist, setPersonExists] = useState(false);
  const [personId, setPersonId] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const startDate = React.useRef(Date.now());
  const myTimeout = useRef(null);
  const [timeoutId, setTimeoutId] = useState(null);
  useEffect(() => {
    if (activeStep === 3) {
      Network.getStatus().then((status) => {
        if (status.connected) {
          // getProjects()
          //   .then((resp) => {
          //     console.log(resp);
          //     setProjectNameList(resp);
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
          getAssignedProjects(loggedInUser.cpId)
            .then((assignedProjectRes) => {
              assignedProjectRes = assignedProjectRes.filter((el) => el.projectId !== null);
              assignedProjectRes = assignedProjectRes.map((el) => ({ ...el, projectId: el?.projectId?.projectId, projectName: el?.projectId?.projectName, projectData: el?.projectId }))
              console.log({ assignedProjectRes });
              setProjectNameList(assignedProjectRes);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          offlineToast();
        }
      });
    }
  }, [activeStep]);
  useEffect(() => {
    if (activeStep === 2) {
      Network.getStatus().then((status) => {
        if (status.connected) {
          getNationality()
            .then((resp) => {
              setNationality(resp);
            })
            .catch((err) => {
              handleErrors(err, "add lead - get nationality");
            });

          getProfessions()
            .then((resp) => {
              console.log(resp);
              setWorksIn(resp);
            })
            .catch((err) => {
              handleErrors(err, "add lead - get professions");
            });
          getNative()
            .then((resp) => {
              setNative(resp);
            })
            .catch((err) => {
              handleErrors(err, "add lead - get native");
            });
          getBudget()
            .then((resp) => {
              setBudgetList(resp);
            })
            .catch((err) => {
              handleErrors(err, "add lead - get budget");
            });
        } else {
          offlineToast();
        }
      });
    }
  }, [activeStep]);
  useEffect(() => {
    let validation = validatePersonalDetailsForButton();
    if (validation.flag) {
      setPersonalButtonNext(true);
    } else {
      setPersonalButtonNext(false);
    }
  }, [personalButtonNext, validatePersonalDetailsForButton]);

  useEffect(() => {
    let validation = validateGeneralDetailsForButton();
    if (validation.flag) {
      setGeneralButtonNext(true);
    } else {
      setGeneralButtonNext(false);
    }
  }, [generalButtonNext, validateGeneralDetailsForButton]);
  useEffect(() => {
    let validation = validateProjectFieldsForButton();
    if (validation.flag) {
      setProjectButtonNext(true);
    } else {
      setProjectButtonNext(false);
    }
  }, [projectButtonNext, validateProjectFieldsForButton]);
  // !!For verifyOtp TimeOut
  useEffect(() => {
    console.log({ myTimeout }, { verifiedPhoneNumber })
    if (verifiedPhoneNumber) {
      // clearTimeout(myTimeout);
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
  }, [verifiedPhoneNumber])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (activeStep === 3) {
      console.log("done");
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 1) {
      handleClose();
    }
  };
  const PAN_CardCheck = useRef(
    debounce((e, _apiToken) => {
      Network.getStatus().then((resp) => {
        if (resp.connected) {
          // console.log(e);
          getPAN_cardDetails(e, _apiToken)
            .then((res) => {
              setIsLoadingPan(false);
              console.log(res.data);
              if (res?.data?.message_code === "success") {
                checkForUniqueDocs(e)
                  .then((resp) => {
                    console.log(resp);
                    if (resp.length) {
                      setHelperText((pre) => {
                        pre.panNumber = "User already exists";
                        pre.isPanValid = false;
                        return { ...pre };
                      });
                      setPanName("");
                      setPanObject("");
                    } else {
                      console.log(
                        "res.data.data.full_name",
                        res.data.data.full_name
                      );
                      setPanName(res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " "));
                      setPanObject(res.data.data);
                      if (res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ") !== personalDetail.name) {
                        setOpenConfirmation(true);
                      }
                      setHelperText((pre) => {
                        pre.panNumber = "";
                        return { ...pre };
                      });
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                setHelperText((pre) => {
                  pre.isPanValid = true;
                  return { ...pre };
                });
              } else {
                setIsLoadingPan(false);
                // setPAN_cardIsVerified(false);
              }
            })
            .catch((err) => {
              setIsLoadingPan(false);
              console.log("err", err);
              // console.log(err?.response?.data);
              if (err?.response?.data?.message) {
                setPanName("");
                let pre = { ...helperText };
                pre.panNumber = err?.response?.data?.message;
                pre.isPanValid = false;
                setHelperText({ ...pre });
              }
              handleErrors(err, "add lead - pan card");
            });
        } else {
          offlineToast();
        }
      });
    }, 800)
  ).current;

  function validationPersonalDetails() {
    var form = true;
    if (personalDetail.name === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.name = "Please Enter Name";
        return { ...preValue };
      });
    }
    if (personalDetail.email === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.email = "Please Enter Email";
        return { ...preValue };
      });
    }

    if (personalDetail.phoneNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPhoneNumber = "Please Enter Phone Number";
        return { ...preValue };
      });
    } else {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
    }

    return {
      flag: form,
    };
  }
  function validatePersonalDetails() {
    let flag = validationPersonalDetails();
    if (
      flag.flag &&
      helperText.name === "" &&
      helperText.email === "" &&
      helperText.isPhoneNumber === "" &&
      verifiedPhoneNumber
    ) {
      handleNext();
    }
  }

  function validatePersonalDetailsForButton() {
    var form = true;
    if (helperText.name !== "" || personalDetail.name === "") {
      form = false;
    }
    if (helperText.email !== "" || personalDetail.email === "") {
      form = false;
    }
    if (helperText.isPhoneNumber !== "" || personalDetail.phoneNumber === "") {
      form = false;
    }
    if (verifiedPhoneNumber === false) {
      form = false;
    }
    return {
      flag: form,
    };
  }

  function validationGeneralDetails() {
    var form = true;
    if (generalDetail.nationality === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.nationality = "Please Select Nationality";
        return { ...preValue };
      });
    }
    if (generalDetail.native === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.native = "Please Select Native";
        return { ...preValue };
      });
    }

    if (generalDetail.worksIn === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.worksIn = "Please Select worksIn";
        return { ...preValue };
      });
    }
    if (generalDetail.budget === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.budget = "Please Select Budget";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validateGeneralDetails() {
    let flag = validationGeneralDetails();
    if (
      flag.flag &&
      helperText.nationality === "" &&
      helperText.native === "" &&
      helperText.worksIn === "" &&
      helperText.budget === ""
    ) {
      handleNext();
    }
  }

  function validateGeneralDetailsForButton() {
    var form = true;
    if (helperText.nationality !== "" || generalDetail.nationality === "") {
      form = false;
    }
    if (helperText.native !== "" || generalDetail.native === "") {
      form = false;
    }
    if (helperText.worksIn !== "" || generalDetail.worksIn === "") {
      form = false;
    }
    if (helperText.budget !== "" || generalDetail.budget === "") {
      form = false;
    }
    return {
      flag: form,
    };
  }

  function validationProjectFields() {
    var form = true;
    projectFieldArray.forEach((el, index) => {
      if (el.selectedProject === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].selectedProject = "Please Select Project First";
          return [...pre];
        });
      }
      if (el.flatUnitType === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].flatUnitType = "Please Select Flat/Unit Type";
          return [...pre];
        });
      }

      // if (el.SitePrefernces === "") {
      //   form = false;
      //   setProjectFieldHelperText((pre) => {
      //     pre[index].SitePrefernces = "Please Select Date";
      //     return [...pre];
      //   });
      // }
    });

    return {
      flag: form,
    };
  }

  function validateProjectFields() {
    console.log(projectFieldArray);
    let flag = validationProjectFields();
    if (flag.flag) {
      handleNext();
    }
  }
  function validateProjectFieldsForButton() {
    var form = true;
    projectFieldArray.forEach((el, index) => {
      if (el.selectedProject === "") {
        form = false;
      }
      if (el.flatUnitType === "") {
        form = false;
      }

      // if (el.SitePrefernces === "") {
      //   form = false;
      // }
    });
    return {
      flag: form,
    };
  }

  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      setVerifiedPhoneNumber(true);
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  function smsTimeOut() {
    if (verifiedPhoneNumber === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setVerifiedPhoneNumber(false);
    }
    setShowOtp(true);
    setOtpTimer(true);
    setResendButton(true);
    setState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setRecievedOtp(null);
  }
  // function smsApiCall() {
  //   setResendButton(false);
  //   // const myTimeout = setTimeout(() => {
  //   //   setResendButton(true);
  //   // }, 180000);
  //   // clearTimeout(myTimeout);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   setShowOtp(true);

  //   let body = {
  //     number: personalDetail.phoneNumber,
  //     isInterNational: isInterNational,
  //     email: personalDetail.email ?? null
  //   };
  //   console.log(body);
  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       if (resp.data.success) {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         setRecievedOtp(parseInt(originalText));
  //         console.log("Add Lead OTP", parseInt(originalText));
  //         // 900000 ;15 min
  //         // 600000;1min
  //         // myTimeout.current
  //         // startTimer();
  //         const id = setTimeout(smsTimeOut, 900000);

  //       } else {
  //         if (resp.data.otp) {
  //           var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //           var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //           setRecievedOtp(parseInt(originalText));
  //           console.log("Add Lead OTP", parseInt(originalText));
  //         } else {
  //           // if (resp?.data?.error?.ErrorMessage) {
  //           //   errorTost(resp?.data?.error?.ErrorMessage);
  //           if (resp?.data?.error?.message) {
  //             errorTost(resp?.data?.error?.message);
  //           } else {
  //             errorTost("Something went wrong");
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       console.log(err.message);
  //     });
  // }
  // function startTimer() {
  //   const id = setTimeout(() => {
  //     smsTimeOut()
  //     startTimer();
  //   }, 900000);
  //   setTimeoutId(id);
  // }


  function smsApiCall() {
  setResendButton(false);
  setState((pre) => {
    pre.otp1 = "";
    pre.otp2 = "";
    pre.otp3 = "";
    pre.otp4 = "";
    return { ...pre };
  });
  setShowOtp(true);

  let body = {
    number: personalDetail.phoneNumber,
    isInterNational: isInterNational,
    email: personalDetail.email ?? null
  };
  // console.log(body);

  sendOTPMessage(body)
    .then((resp) => {
      // Check if the response is successful
      if (resp.data) {
        const encryptedOtp = resp.data.otp;
        // console.log("Encrypted OTP received:", encryptedOtp); // Log the received encrypted OTP

        // Step 1: Decode Base64 (OTP is Base64-encoded)
        var decodedOtp;
        try {
          decodedOtp = atob(encryptedOtp); // Decode base64
          // console.log("Decoded OTP (Base64 to string):", decodedOtp);
        } catch (error) {
          console.error("Base64 decoding failed:", error);
          errorTost("Base64 decoding failed. Please try again.");
          return;
        }

        // Step 2: Decrypt with the same key
        var bytes = CryptoJS.AES.decrypt(decodedOtp, "hts secret key");
        var originalText = bytes.toString(CryptoJS.enc.Utf8);

        // Step 3: Check if decryption was successful
        if (!originalText) {
          console.error("Decryption failed! Key or ciphertext mismatch.");
          errorTost("OTP decryption failed. Please try again.");
          return;
        }

        // Step 4: Ensure OTP is a valid number
        const otp = parseInt(originalText);
        if (isNaN(otp)) {
          console.error("Invalid OTP received:", originalText);
          errorTost("Invalid OTP. Please try again.");
          return;
        }

        // Log the decrypted OTP
        console.log("Add Lead Mobile OTP:", otp);

        // Step 5: Set a 15-minute timeout to prevent resending OTP
        const id = setTimeout(smsTimeOut, 900000);
        setRecievedOtp(otp);

      } else {
        // Handle failure cases
        if (resp?.data?.error?.message) {
          errorTost(resp?.data?.error?.message);
        } else {
          errorTost("Something went wrong.");
        }
      }
    })
    .catch((err) => {
      console.error(err);
      errorTost("An error occurred while sending OTP.");
    });
}
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setResendButton(true);

      // Render a completed state
      return console.log("done");
    } else {
      return (
        <span>
          {" "}
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };
  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  function submit() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        if (personExist === false && helperText.panNumber === "") {
          presentLoader();
          addPersonTable(personalDetail, generalDetail)
            .then((personRes) => {
              console.log({ personRes }, { loggedInUser });
              let preferncedProjectArr = projectFieldArray.filter(({ isPrimary }) => isPrimary === true);
              console.log({ preferncedProjectArr })
              addLeadsTable(
                personRes[0].personId,
                loggedInUser.cpId,
                loggedInUser.fosId,
                preferncedProjectArr[0]?.selectedProjectData?.userId
              )
                .then((result) => {
                  console.log({ result });
                  presentLoader()
                  axios.post(`${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}users/createLeadLoginAuth`, { leadId: result[0]?.leadId, contactNumber: personalDetail?.phoneNumber }).then((val) => {
                    console.log("val", val)
                    dismissLoader()
                    // successTost(val.message)
                    addLeadStatus(result[0].leadId)
                      .then((leadRes) => {
                        let obj = {
                          cpId: loggedInUser.cpId,
                          fosId: loggedInUser.fosId,
                          leadId: result[0].leadId,
                          leadStatus: 'Unclaimed',
                          message: `Lead created by ${loggedInUser.fosId ? loggedInUser?.name + '(FoS), ' + loggedInUser?.cpData?.billingName + '(CP)' : loggedInUser?.billingName + '(CP)'}`
                        }
                        addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })

                        getLeadDetails(result[0].leadId).then((resdata) => {
                          console.log("resdata", resdata);
                          let waObj = {
                            contactNumber: personalDetail.phoneNumber,
                            leadName: personalDetail.name,
                            cpName: loggedInUser.fosId ? loggedInUser?.cpData?.billingName : loggedInUser?.billingName,
                            cuid: 'VJ' +
                              resdata?.data[0]?.leadDisplayId?.replace(
                                resdata?.data[0]?.leadDisplayId?.substring(8, 12),
                                '-' + resdata?.data[0]?.leadDisplayId?.substring(8, 12)
                              )
                          }
                          sendWAMSG(waObj).then((respWa) => {
                            // console.log("whats up", respWa);
                          })
                            .catch((err) => {
                              dismissLoader();
                            });
                        })
                        projectFieldArray.forEach((el) => {
                          addProjectPrefernces(el, personRes[0].personId)
                            .then((project) => {
                              console.log("projectPrefernce", project);
                            })
                            .catch((err) => {
                              dismissLoader();
                              handleErrors(err, "add lead - project pref");
                            });
                        });

                        if (panNumber !== "") {
                          addKYCDoc(
                            result[0].leadId,
                            panNumber,
                            panName,
                            panObject
                          )
                            .then((res) => {
                              dismissLoader();
                              console.log(res);
                            })
                            .catch((err) => {
                              dismissLoader();
                              handleErrors(err, "add lead - kyc doc");
                            });
                        } else {
                          dismissLoader();
                        }
                        getFormatedEmail("Lead Onboarding")
                          .then((resp) => {
                            console.log(resp.data[0].emailTemplate);
                            let message = resp.data[0].emailTemplate.replace(
                              "{{leadName}}",
                              `${personalDetail.name.toUpperCase()}`
                            );
                            sendMail(
                              personalDetail.email,
                              resp.data[0].emailSubject,
                              message
                            );
                            // **message
                            // let messageBody = {
                            //   number: "+" + personalDetail?.phoneNumber,
                            //   message: `You have registered with VjSales Successfully.Keep in touch for further details.`,
                            //   is_international_number: 
                            //   personalDetail?.phoneNumber.toString().substring(0, 2) !== "91"
                            //       ? true
                            //       : false,
                            // };
                            //  sendMessage(messageBody)
                            //   .then((resp) => {
                            //     if (resp.data.success) {
                            //       return true;
                            //     } else {
                            //       if (resp?.data?.error) {
                            //         return false;
                            //       }
                            //     }
                            //   })
                            //   .catch((err) => {
                            //     console.log(err.message);
                            //     return false;
                            //   });
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                        successTost("Lead added successfully");
                        returnRespButton(true);
                        closeModal();
                      })
                      .catch((err) => {
                        dismissLoader();
                        handleErrors(err, "add lead - lead status");
                      });
                  }).catch(err => {
                    dismissLoader()
                    errorTost(err.message)
                  })

                  axios
                    .post(`${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}leadProfile/createProfile`, { leadIds: [result[0]?.leadId] })
                    .then((profileRes) => {
                      console.log("createProfile success:", profileRes?.data)
                      axios
                        .get(`${process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE}matchmaking/leads/${result[0]?.leadId}/scores`)
                        .then((scoresRes) => {
                          console.log("matchmaking scores success:", scoresRes?.data)
                        })
                        .catch((err) => {
                          console.log("matchmaking scores error:", err?.message)
                        })
                    })
                    .catch((err) => {
                      console.log("createProfile error:", err?.message)
                    })

                })
                .catch((err) => {
                  dismissLoader();
                  handleErrors(err, "add lead");
                });
            })
            .catch((err) => {
              dismissLoader();
              handleErrors(err, "add lead - add person");
            });
        }
      } else {
        offlineToast();
      }
    });

    //
  }
  function closeModal() {
    setGeneralDetail({
      nationality: "",
      native: "",
      worksIn: "",
      budget: "",
    });
    setPersonalDetail({
      name: "",
      email: "",
      phoneNumber: "",
    });
    setProjectFieldArray([
      {
        selectedProject: "",
        flatUnitType: "",
        SitePrefernces: null,
      },
    ]);
    setHelperText({
      name: "",
      email: "",
      isPhoneNumber: "",
      panNumber: "",
      isPanValid: false,
      nationality: "",
      native: "",
      worksIn: "",
      budget: "",
    });
    setActiveStep(1);
    handleClose();
  }

  // const checkPersonExistsInTable = debounce((e) => {
  //   if (window.navigator.onLine) {
  //     checkPersonExists(e)
  //       .then((resp) => {
  //         if (resp.length) {
  //           setPersonId(resp[0].personId);
  //           setPersonalDetail((pre) => {
  //             pre.name = resp[0].name;
  //             pre.phoneNumber = "+91" + resp[0].contactNumber;
  //             pre.gender = resp[0].gender;
  //             pre.disabledName = true;
  //             pre.disabledPhoneNumber = true;
  //             pre.disabledGender = true;
  //             return { ...pre };
  //           });
  //           setGeneralDetail((pre) => {
  //             pre.nationality = resp[0].Nationality.nationalityId;
  //             pre.worksIn = resp[0].Professions.professionId;
  //             pre.native = resp[0].native;
  //             pre.disabledNationality = true;
  //             pre.disabledNative = true;
  //             pre.disabledWorksIn = true;
  //             return { ...pre };
  //           });

  //           let tempArray = projectFieldArray;
  //           tempArray = resp[0].ProjectPreference.map((el, index) => {
  //             return {
  //               selectedProject: el.projectName,
  //               flatUnitType: el.unitType,
  //               SitePrefernces: el.dateTime,
  //               isPrimary: el.isPrimary,
  //               alreadyAdded: true,
  //             };
  //           });
  //           setProjectFieldArray(tempArray);
  //           setProjectFieldHelperText(tempArray.map((_) => helperTextObj));
  //           setHelperText((pre) => {
  //             pre.email = "";
  //             pre.name = "";
  //             pre.nationality = "";
  //             pre.isPhoneNumber = "";
  //             pre.worksIn = "";
  //             pre.navtive = "";
  //             return { ...pre };
  //           });
  //           setPersonExists(true);
  //           console.log({ projectFieldArray });
  //         } else {
  //           setPersonId("");
  //           setPersonalDetail((pre) => {
  //             pre.name = "";
  //             pre.gender = "Male";
  //             pre.phoneNumber = "";
  //             pre.disabledName = false;
  //             pre.disabledPhoneNumber = false;
  //             pre.disabledGender = false;
  //             return { ...pre };
  //           });
  //           setGeneralDetail((pre) => {
  //             pre.nationality = "";
  //             pre.worksIn = "";
  //             pre.native = "";
  //             pre.disabledNationality = false;
  //             pre.disabledNative = false;
  //             pre.disabledWorksIn = false;
  //             return { ...pre };
  //           });
  //           setProjectFieldArray([
  //             {
  //               selectedProject: "",
  //               flatUnitType: "",
  //               SitePrefernces: "",
  //               isPrimary: false,
  //               alreadyAdded: false,
  //             },
  //           ]);
  //           setHelperText((pre) => {
  //             pre.email = "";
  //             pre.name = "";
  //             pre.nationality = "";
  //             pre.worksIn = "";
  //             pre.navtive = "";
  //             return { ...pre };
  //           });
  //           setPersonExists(false);
  //         }
  //       })
  //       .catch((err) => {
  //         handleErrors(err, "add lead - check person exists");
  //       });
  //   } else {
  //     offlineToast();
  //   }
  // }, 800);
  const IsNumberBlackListed = debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        if (resp.length > 0) {
          setVerifiedPhoneNumber(false);
          //  setHelperText((pre) => {
          //   pre.isPhoneNumber = "";
          //   return { ...pre };
          // });
          setHelperText((pre) => {
            pre.isPhoneNumber = "This number is already in use!";
            return { ...pre };
          });
        } else {
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            return { ...pre };
          });
          // checkPhoneNumberExists(e)
          //   .then((personTableRes) => {
          //     console.log(personTableRes);
          //     if (personTableRes.length > 0) {
          //       setHelperText((pre) => {
          //         pre.isPhoneNumber = `This number already exists with lead name ${personTableRes[0].name}`;
          //         return { ...pre };
          //       });
          //     } else {
          //       setHelperText((pre) => {
          //         pre.isPhoneNumber = "";
          //         return { ...pre };
          //       });
          //     }
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);
  function funGetProjectUnitType(projectId, index) {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        getProjectUnitType(projectId)
          .then((resp) => {
            console.log(resp);
            resp = resp.map((el) => {
              if (el?.displaytype !== null && el?.displaytype !== '') {
                return el?.type + '(' + el?.displaytype + ')';
              } else {
                return el?.type;
              }
            });
            console.log(resp);
            setProjectFieldArray((pre) => {
              pre[index].availableUnitType = resp;
              return [...pre];
            });
            setProjectUnitArray(resp);
          })
          .catch((err) => {
            handleErrors(err, "add lead - get project unit type");
          });
      } else {
        offlineToast();
      }
    });
  }
  function sendMail(email, subject, message) {
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        console.log(resp.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperHeader}>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </span>
            {/* <img className={cssClasses.block} src={block} alt="icon"></img> */}
            <div>Add Lead</div>
            {activeStep !== 1 && (
              <img
                className={cssClasses.backArrow}
                src={backArrow}
                onClick={handleBack}
                alt={"backArrow"}
                tabIndex="0"
              ></img>
            )}
          </div>

          <div className={cssClasses.wrapperStepper}>
            <MobileStepper
              variant="progress"
              steps={totalSteps}
              position="static"
              activeStep={activeStep}
              className={classes.stepper}
              sx={{
                maxWidth: "100%",
                // maxWidth:600,
                flexGrow: 1,
                margin: "0 auto",
                background: "#ffff ",
              }}
            />
          </div>
          <div className={cssClasses.label}>
            {totalSteps - activeStep - 1} Steps to add Lead
          </div>
          {activeStep === 1 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>General Details</div>
              <div className={cssClasses.addHeightToMiddleContent}>
                <div style={{ textTransform: "uppercase" }}>
                  <CustomInput
                    value={personalDetail.name}
                    label={"Name"}
                    mandatory={true}
                    disabled={personalDetail.disabledName}
                    handleChange={(newValue) => {
                      newValue = newValue.trimStart();
                      var alphabet = /^[A-Z*\sa-z]*$/;
                      if (newValue.match(alphabet) || newValue === "") {
                        if (newValue.length <= 40) {
                          setPersonalDetail((pre) => {
                            pre.name = newValue;
                            return Object.assign({}, pre);
                          });
                        }
                      }
                      if (newValue !== "") {
                        setHelperText((pre) => {
                          pre.name = "";
                          return { ...pre };
                        });
                      } else {
                        helperText.name = "Please Enter Name";
                      }
                    }}
                    placeholder="Enter Name"
                    inputType="label"
                    helperText={helperText.name}
                  />
                </div>
                <div>
                  <CustomInput
                    label={"Email Id"}
                    mandatory={true}
                    value={personalDetail.email}
                    handleChange={(newValue) => {
                      newValue = newValue.trimStart();
                      const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (!newValue.trim()) {
                        helperText.email = "Please Enter Email Id";
                      } else if (!newValue.match(emailIDCond)) {
                        helperText.email =
                          "Please Enter Email in Proper Format";
                      } else {
                        // checkPersonExistsInTable(newValue);
                        helperText.email = "";
                      }
                      if (newValue.length <= 50) {
                        setPersonalDetail((pre) => {
                          pre.email = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }}
                    placeholder="Enter contact person Email"
                    inputType="label"
                    helperText={helperText.email}
                  />
                </div>
                <div style={{ position: "relative" }}>
                  <div className={cssClasses.blockLabel}>
                    Phone Number <span style={{ color: "red" }}> *</span>
                  </div>
                  <PhoneInput
                    defaultCountry="IN"
                    disabled={showOtp || verifiedPhoneNumber || resendButton}
                    value={personalDetail.phoneNumber}
                    placeholder="Enter phone number"
                    onChange={(phone) => {
                      console.log(phone);
                      if (phone?.length > 0 && phone !== undefined) {
                        phone = phone.trim();
                      }
                      setPersonalDetail((pre) => {
                        pre["phoneNumber"] = phone;
                        return Object.assign({}, pre);
                      });
                      if (phone !== undefined) {
                        setVerifiedPhoneNumber(false);
                        if (phone.length >= 1) {
                          if (isValidPhoneNumber(phone) === false) {
                            setVerifiedPhoneNumber(false);
                            helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                            setShowOtp(false);
                          } else {
                            helperText.isPhoneNumber = "verifying...";
                            if (phone?.substring(0, 3) === "+91") {
                              setIsInterNational(false);
                            } else {
                              setIsInterNational(true);
                            }
                            IsNumberBlackListed(phone);
                          }
                        }
                      } else {
                        helperText.isPhoneNumber = "Please Enter  Phone Number";
                        setShowOtp(false);
                      }
                    }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "1.4rem",
                      lineHeight: "1.66",
                    }}
                  >
                    {helperText.isPhoneNumber}
                  </p>
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber === false &&
                    otptimer === false &&
                    showOtp === false &&
                    personalDetail.phoneNumber !== "" && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          setResendButton(false);
                          smsApiCall();
                        }}
                      >
                        Verify Otp
                      </div>
                    )}
                  {verifiedPhoneNumber === false &&
                    showOtp === true &&
                    resendButton === true && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          setHelperText((pre) => {
                            pre.isPhoneNumber = "";
                            return { ...pre };
                          });
                          smsApiCall();
                        }}
                      >
                        Resend Otp
                      </div>
                    )}
                  {verifiedPhoneNumber === false &&
                    showOtp === true &&
                    resendButton === false && (
                      <div className={cssClasses.resendOtp}>
                        {" "}
                        Resend Otp in{" "}
                        {/* <Countdown date={startDate.current + 180000} controlled={true} renderer={renderer} key={restartCountDown}/> */}
                        <CountdownTimer
                          startFrom={180}
                          onComplete={() => {
                            setResendButton(true);
                          }}
                          timeFormatter={(time) => {
                            return (
                              <span>
                                {`0${Math.floor(time / 60)}`.slice(-2)}:
                                {`0${time % 60}`.slice(-2)}
                              </span>
                            );
                          }}
                        />
                      </div>
                    )}
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber &&
                    otptimer === false && (
                      <div className={cssClasses.verifyOtp}>
                        <CheckCircleSharpIcon
                          style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                          color={"success"}
                        />
                      </div>
                    )}
                  {showOtp && (
                    <div className={cssClasses.otpContainer}>
                      <input
                        className={cssClasses.otpInput}
                        name="otp1"
                        type="text"
                        autoComplete="off"
                        value={state.otp1}
                        // onKeyPress={keyPressed}
                        onChange={(e) => optChange("otp1", e)}
                        tabIndex="1"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id="opt-0"
                      />
                      <input
                        name="otp2"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp2}
                        onChange={(e) => optChange("otp2", e)}
                        tabIndex="2"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id="opt-1"
                      />
                      <input
                        name="otp3"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp3}
                        onChange={(e) => optChange("otp3", e)}
                        tabIndex="3"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id="opt-2"
                      />
                      <input
                        name="otp4"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp4}
                        onChange={(e) => optChange("otp4", e)}
                        tabIndex="4"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id="opt-3"
                      />

                      <div>
                        <Button
                          tabIndex={5}
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#155EEF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          btnName={"Submit OTP"}
                          clicked={submitOtp}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Gender <span style={{ color: "red" }}> *</span>
                  </div>
                  <FormControl disabled={personalDetail.disabledGender}>
                    {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: "#155EEF !important",
                          fontSize: "2rem !important",
                        },
                      }}
                      value={personalDetail.gender}
                      onChange={(e) => {
                        console.log(typeof e.target.value);
                        setPersonalDetail((pre) => {
                          pre.gender = e.target.value;
                          return Object.assign({}, pre);
                        });
                      }}
                    >
                      <FormControlLabel
                        className={classes.radioLabel}
                        value={"Male"}
                        control={<Radio />}
                        label={<div className={classes.radioLabel}>Male</div>}
                      />
                      <FormControlLabel
                        className={classes.radioLabel}
                        value={"Female"}
                        control={<Radio />}
                        label={<div className={classes.radioLabel}>Female</div>}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <div>
                {personalButtonNext ? (
                  <Button
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    btnName={"Proceed"}
                    clicked={validatePersonalDetails}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                ) : (
                  <Button
                    style={{
                      color: "#155EEF",
                      border: "1px solid #155EEF",
                      backgroundColor: "#ffffff",
                    }}
                    clicked={validatePersonalDetails}
                    btnName={"Proceed"}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                )}
              </div>
            </div>
          )}
          {activeStep === 2 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>Personal Details</div>
              <div className={cssClasses.addHeightToMiddleContent}>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Nationality <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={nationality.map((element, id) => {
                      return {
                        label: element.nationality,
                        value: element.nationalityId,
                      };
                    })}
                    selectedValue={generalDetail.nationality}
                    onChangeSelect={(value) => {
                      setGeneralDetail((pre) => {
                        pre.nationality = value;
                        return { ...pre };
                      });
                      if (generalDetail.nationality !== "") {
                        helperText.nationality = "";
                      } else {
                        helperText.nationality = "Please Select Nationality";
                      }
                    }}
                    placeHolder={"Nationality"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.nationality}
                    disable={generalDetail.disabledNationality}
                  />
                </div>

                <div>
                  <div className={cssClasses.blockLabel}>
                    Native <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={native.map((element, id) => {
                      return {
                        label: element.native,
                        value: element.nativeId,
                      };
                    })}
                    selectedValue={generalDetail.native}
                    onChangeSelect={(value) => {
                      setGeneralDetail((pre) => {
                        pre.native = value;
                        return { ...pre };
                      });
                      if (generalDetail.native !== "") {
                        helperText.native = "";
                      } else {
                        helperText.nationality = "Please Select Native";
                      }
                    }}
                    placeHolder={"Native"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.native}
                    disable={generalDetail.disabledNative}
                  />
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    WorksIn <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={wroksIn.map((element, id) => {
                      return {
                        label: element.profession,
                        value: element.professionId,
                      };
                    })}
                    selectedValue={generalDetail.worksIn}
                    onChangeSelect={(value) => {
                      console.log(value);
                      console.log(generalDetail.worksIn);
                      // console.log(value);
                      setGeneralDetail((pre) => {
                        pre.worksIn = value;
                        return { ...pre };
                      });
                      if (generalDetail.worksIn !== "") {
                        helperText.worksIn = "";
                      } else {
                        helperText.worksIn = "Please Select WorksIn";
                      }
                    }}
                    placeHolder={"Works In"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.worksIn}
                    disable={generalDetail.disabledWorksIn}
                  />
                </div>
                <div>
                  <div className={cssClasses.blockLabel}>
                    Budget <span style={{ color: "red" }}> *</span>
                  </div>
                  <DropDown
                    list={budgetList.map((element, id) => {
                      return {
                        label: element.budget,
                        value: element.budgetId,
                      };
                    })}
                    selectedValue={generalDetail.budget}
                    onChangeSelect={(value) => {
                      setGeneralDetail((pre) => {
                        pre.budget = value;
                        return { ...pre };
                      });
                      if (generalDetail.budget !== "") {
                        helperText.budget = "";
                      } else {
                        helperText.budget = "Please Select Budget";
                      }
                    }}
                    placeHolder={"Budget"}
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.budget}
                    disable={generalDetail.disabledBudget}
                  />
                </div>
              </div>
              <div>
                {generalButtonNext ? (
                  <Button
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    btnName={"Proceed"}
                    clicked={validateGeneralDetails}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                ) : (
                  <Button
                    style={{
                      color: "#155EEF",
                      border: "1px solid #155EEF",
                      backgroundColor: "#ffffff",
                    }}
                    clicked={validateGeneralDetails}
                    btnName={"Proceed"}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                )}
              </div>
            </div>
          )}
          {activeStep === 3 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>Project Details</div>
              <div className={cssClasses.wrapperProjectDeatils}>
                {projectFieldArray.map((each, index) => (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "2rem",
                    }}
                  >
                    {index >= 1 && (
                      <span
                        className={classes.closeIcon}
                        tabIndex={0}
                        onClick={() => {
                          projectFieldArray.forEach((each) => {
                            if (projectFieldArray[index].isPrimary) {
                              projectFieldArray[index - 1].isPrimary = true;
                            }
                          });
                          let arr = projectFieldArray;
                          arr.splice(index, 1);
                          setProjectFieldArray([...arr]);
                          let helperTextArr = projectFieldHelperText;
                          projectFieldHelperText.splice(index, 1);
                          setProjectFieldHelperText([...helperTextArr]);
                        }}
                      >
                        <Close width={"1.2rem"} height={"1.2rem"} />
                      </span>
                    )}
                    {each.alreadyAdded ? (
                      <>
                        <div>
                          <CustomInput
                            value={each.selectedProject}
                            disabled={true}
                            label={"Project"}
                            mandatory={true}
                          />
                        </div>
                        <div>
                          <CustomInput
                            value={each.flatUnitType}
                            disabled={true}
                            label={"Flat/Unit Type"}
                            mandatory={true}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Project <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={projectNameList.map((element, id) => {
                              return {
                                label: element.projectName,
                                value: element.projectName,
                              };
                            })}
                            selectedValue={each.selectedProject}
                            onChangeSelect={(value) => {
                              let selectedProject;
                              selectedProject = projectNameList.filter(
                                ({ projectName }) => value === projectName
                              );
                              setProjectFieldArray((pre) => {
                                console.log(pre[index]);
                                pre[index].selectedProject = value;
                                pre[index].flatUnitType = "";
                                pre[index].selectedProjectData = selectedProject[0];
                                return [...pre];
                              });

                              funGetProjectUnitType(
                                selectedProject[0].projectId,
                                index
                              );

                              setProjectFieldHelperText((pre) => {
                                pre[index].selectedProject = "";
                                return [...pre];
                              });
                              // each.selectedProject=value;
                            }}
                            placeHolder={"Select Project"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={
                              projectFieldHelperText[index]?.selectedProject ??
                              ""
                            }
                            disable={each.alreadyAdded}
                          />
                        </div>
                        <div>
                          <div className={cssClasses.blockLabel}>
                            Flat/Unit Type
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <DropDown
                            list={uniq(each.availableUnitType)}
                            selectedValue={each.flatUnitType}
                            onChangeSelect={(value) => {
                              setProjectFieldArray((pre) => {
                                console.log(pre);
                                pre[index].flatUnitType = value;
                                return [...pre];
                              });
                              setProjectFieldHelperText((pre) => {
                                pre[index].flatUnitType = "";
                                return [...pre];
                              });
                              // each.selectedProject=value;
                            }}
                            placeHolder={"Flat/Unit Type"}
                            //style.color is placeHolder's color
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                            }}
                            helperText={
                              projectFieldHelperText[index]?.flatUnitType ?? ""
                            }
                            disable={each.alreadyAdded}
                          />
                        </div>
                      </>
                    )}
                    <div>
                      <div className={cssClasses.blockLabel}>
                        Site Visit Date
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </div>
                      <DateComponent
                        value={each.SitePrefernces}
                        onChangeDate={(value) => {
                          console.log("value: ", value);
                          console.log(each);
                          setProjectFieldArray((pre) => {
                            console.log(pre);
                            pre[index].SitePrefernces = value;
                            return [...pre];
                          });
                          setProjectFieldHelperText((pre) => {
                            console.log(pre);
                            pre[index].SitePrefernces = "";
                            return [...pre];
                          });
                        }}
                        helperText={
                          projectFieldHelperText[index]?.SitePrefernces ?? ""
                        }
                        disable={each.alreadyAdded}
                      />
                    </div>
                    <div>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={projectFieldArray[index].isPrimary}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: "#155EEF !important",
                              fontSize: "2rem !important",
                            },
                          }}
                          onChange={(e) => {
                            projectFieldArray.forEach((el, arrayIndex) => {
                              setProjectFieldArray((pre) => {
                                pre = pre.map((m) => ({
                                  ...m,
                                  isPrimary: false,
                                }));
                                pre[index].isPrimary = true;
                                return [...pre];
                              });
                            });
                            console.log(projectFieldArray);
                          }}
                        >
                          <FormControlLabel
                            className={classes.radioLabel}
                            value={true}
                            control={<Radio />}
                            label={
                              <div className={classes.radioLabel}>
                                Mark as primary
                              </div>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div>
                      {projectFieldArray.length === index + 1 && (
                        // projectNameList.length >= projectFieldArray.length &&
                        <div className={cssClasses.wrapperAddPrefernce}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              columnGap: "1rem",
                            }}
                          >
                            <img src={AddIcon} alt={"addIcon"}></img>
                            <span
                              className={cssClasses.addPrefernceText}
                              onClick={() => {
                                let value = false;
                                value = projectFieldArray.every((el) => {
                                  if (
                                    // el.SitePrefernces !== "" &&
                                    el.flatUnitType !== "" &&
                                    el.selectedProject !== ""
                                  ) {
                                    return true;
                                  } else {
                                    validationProjectFields();
                                    return false;
                                  }
                                });
                                console.log(value);
                                if (value === true) {
                                  let tempArray = projectFieldArray;
                                  let helperText = projectFieldHelperText;
                                  tempArray.push({
                                    selectedProject: "",
                                    flatUnitType: "",
                                    SitePrefernces: null,
                                    isPrimary: false,
                                    availableUnitType: [],
                                    alreadyAdded: false,
                                    selectedProjectData: null
                                  });
                                  helperText.push({
                                    selectedProject: "",
                                    flatUnitType: "",
                                    SitePrefernces: "",
                                  });
                                  setProjectFieldArray([...tempArray]);
                                  setProjectFieldHelperText([...helperText]);
                                }
                              }}
                            >
                              Add another Preference
                            </span>
                          </div>
                          {/* {index >= 1 && (
                            <span
                              className={cssClasses.addPrefernceText}
                              onClick={() => {
                                setProjectFieldArray((pre) => {
                                  pre.pop();
                                  return [...pre];
                                });
                              }}
                            >
                              Delete Preference
                            </span>
                          )} */}
                        </div>
                      )}

                      <Divider
                        sx={{
                          border: " 1px solid #98A2B3",
                          /* Shadow/xs */
                          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        }}
                      ></Divider>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                {projectButtonNext ? (
                  <Button
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    btnName={"Proceed"}
                    clicked={validateProjectFields}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                ) : (
                  <Button
                    style={{
                      color: "#155EEF",
                      border: "1px solid #155EEF",
                      backgroundColor: "#ffffff",
                    }}
                    clicked={validateProjectFields}
                    btnName={"Proceed"}
                    btnIcon={<RightArrow />}
                    iconPosition={"right"}
                  />
                )}
              </div>
            </div>
          )}
          {activeStep === 4 && (
            <div className={cssClasses.wrapperContactDeatils}>
              <div className={cssClasses.detailText}>KYC</div>
              <div>
                <CustomInput
                  label={"PAN Number"}
                  value={panNumber}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    newValue = newValue.toUpperCase();
                    var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

                    if (!regex.test(newValue)) {
                      helperText.isPanValid = false;
                      setPanName("");
                      helperText.panNumber = "Please enter Valid PAN number.";
                    } else {
                      helperText.panNumber = " verifying...";

                      if (newValue.length === 10) {
                        // if(_isValid.flag) {
                        setIsLoadingPan(true);
                        PAN_CardCheck(newValue.toUpperCase());
                      }
                    }
                    if (newValue.length <= 10) {
                      setPanNumber(newValue);
                    }
                    if (newValue.length === 0) {
                      helperText.panNumber = "";
                    }
                  }}
                  placeholder="Enter PAN Number (Optional)"
                  inputType="label"
                  helperText={helperText.panNumber}
                  isLoading={isLoadingPan}
                  greenTick={helperText.isPanValid}
                />
              </div>
              {panName && (
                <div className={cssClasses.wrapperPanName}>{panName}</div>
              )}
              <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#155EEF",
                }}
                clicked={submit}
                btnName={"Submit"}
              />
            </div>
          )}
          <ConfirmationAlert
            open={openConfirmation}
            close={() => {
              setOpenConfirmation(false);
            }}
            icon={<InfoIcon width={"4.8rem"} height={"4.8rem"} />}
            title={"Info !"}
            subTitle={
              `Lead name is different from that of PAN number. Do you wish to create lead with name ${panName}?`
            }
            confirm={(value) => {
              if (value === "confirmed") {
                setPersonalDetail((pre) => {
                  pre.name = panName;
                  return { ...pre };
                });
              }
              setOpenConfirmation(false);
              console.log(value);
            }}
            buttonTitle={"No"}
            returnRespButton={"Yes"}
          />
        </div>
      </Box>
    </Modal>
  );
}
